// Product Variant Stock Update Fix
// Add this to assets/product-stock-updater.js
// Integrates with your existing app.js getActiveVariant function

(function() {
  'use strict';
  
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('[data-product-form]');
    
    if (!form) return;
    
    // Get variants data from the form
    const variantsData = form.getAttribute('data-variants');
    let variants = [];
    
    if (variantsData) {
      try {
        variants = JSON.parse(decodeURIComponent(variantsData));
      } catch (e) {
        console.error('Error parsing variants data:', e);
      }
    }
    
	  // Function to update stock display
	  function updateStockDisplay(variant) {
	    if (!variant) return;

	    const theme = window.theme || {};
	    const availabilityTextBase = theme.availability || 'Available';
	    const availabilityForBackorderText = availabilityTextBase.includes('Backorder') ? availabilityTextBase : `${availabilityTextBase} for Backorder`;
      
      const stockContainer = document.getElementById('variant-inventory');
      const stockNumber = document.querySelector('.stock-number');
      const stockMessageInStock = document.querySelector('.stock-message-instock');
      const stockMessageSoldOut = document.querySelector('.stock-message-sold-out');
      const productBlockStock = document.querySelector('.product-block--stock-point');
      
      if (!stockContainer) return;
      
      console.log('Updating stock for variant:', variant);
      
      // Check if variant is available
      if (variant.available) {
        // Show in-stock message
        if (stockMessageSoldOut) {
          stockMessageSoldOut.style.display = 'none';
        }
        
        if (productBlockStock) {
          productBlockStock.style.display = 'block';
        }
        
	        if (stockNumber) {
	          // Check inventory management
	          if (variant.inventory_management === 'shopify') {
	            if (variant.inventory_policy === 'continue') {
	              stockNumber.textContent = variant.inventory_quantity > 0 ? variant.inventory_quantity : availabilityForBackorderText;
	            } else {
	              // Show actual quantity
	              stockNumber.textContent = variant.inventory_quantity;
	            }
	          } else {
	            stockNumber.textContent = availabilityForBackorderText;
	          }
	        }
        
        if (stockMessageInStock) {
          stockMessageInStock.style.display = 'block';
        }
      } else {
        // Show sold out message
        if (productBlockStock) {
          productBlockStock.style.display = 'none';
        }
        
        if (stockMessageInStock) {
          stockMessageInStock.style.display = 'none';
        }
        
        if (stockMessageSoldOut) {
          stockMessageSoldOut.style.display = 'block';
        }
      }
    }
    
    // Function to get variant by matching options (mimics your getActiveVariant logic)
    function getVariantFromOptions() {
      const option1Input = form.querySelector('[name="option1"], [name="options[option1]"]');
      const option2Input = form.querySelector('[name="option2"], [name="options[option2]"]');
      const option3Input = form.querySelector('[name="option3"], [name="options[option3]"]');
      
      const formOptions = {
        option1: option1Input ? option1Input.value : null,
        option2: option2Input ? option2Input.value : null,
        option3: option3Input ? option3Input.value : null
      };
      
      let selectedVariant = null;
      
      if (variants != null) {
        variants.forEach(function(variant) {
          if (variant.option1 === formOptions.option1 && 
              variant.option2 === formOptions.option2 && 
              variant.option3 === formOptions.option3) {
            selectedVariant = variant;
            return false;
          }
        });
      }
      
      return selectedVariant;
    }
    
    // Listen for any option input changes
    const optionInputs = form.querySelectorAll('input[name^="option"], select[name^="option"]');
    
    optionInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        console.log('Option changed:', this.name, this.value);
        // Small delay to ensure all options are updated
        setTimeout(function() {
          const selectedVariant = getVariantFromOptions();
          if (selectedVariant) {
            updateStockDisplay(selectedVariant);
          }
        }, 50);
      });
    });
    
    // Listen for clicks on variant option buttons (pill style)
    const optionButtons = form.querySelectorAll('[data-variant-option-button], .product-form__input input[type="radio"]');
    
    optionButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        console.log('Option button clicked');
        setTimeout(function() {
          const selectedVariant = getVariantFromOptions();
          if (selectedVariant) {
            updateStockDisplay(selectedVariant);
          }
        }, 100);
      });
    });
    
    // Also listen for changes on the hidden variant ID input
    const hiddenInput = document.getElementById('js-product-id');
    
    if (hiddenInput) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            const variantId = parseInt(hiddenInput.value);
            const selectedVariant = variants.find(function(v) {
              return v.id === variantId;
            });
            
            if (selectedVariant) {
              console.log('Hidden input changed, updating stock');
              updateStockDisplay(selectedVariant);
            }
          }
        });
      });
      
      observer.observe(hiddenInput, {
        attributes: true,
        attributeFilter: ['value', 'data-inventory-quantity']
      });
    }
    
    // Listen for form submission to ensure we catch any missed updates
    form.addEventListener('submit', function() {
      const selectedVariant = getVariantFromOptions();
      if (selectedVariant) {
        updateStockDisplay(selectedVariant);
      }
    });
  });
})();
